import {doc,runTransaction} from 'firebase/firestore';

export const MAX_TRADE_COPIES=400;
const validId=id=>typeof id==='string'&&id.length>0&&id.length<=300&&!id.includes('/');

// Stable destinations and a single transaction make retries safe: either every
// account receives the trade, or none does. Never overwrite an acknowledged copy.
export async function createSavedTrades(db,uid,trade,accountIds=[trade.accountId||'']){
  const accounts=[...new Set(accountIds)];
  if(!uid||!validId(trade.id)||!accounts.length||accounts.length>MAX_TRADE_COPIES||accounts.some(id=>id!==''&&!validId(id)))throw new Error('Choose up to 400 accounts and try again.');
  const copies=accounts.map(accountId=>({...trade,
    id:accounts.length===1&&trade.accountId!=='__ALL__'?trade.id:`${trade.id}--${accountId||'journal'}`,
    accountId,saveGroupId:trade.id,archiveFolderId:null,archivedAt:null,deleted:false,isPublic:false,
  }));
  const refs=copies.map(copy=>doc(db,'users',uid,'trades',copy.id));
  return runTransaction(db,async tx=>{
    const snapshots=await Promise.all(refs.map(ref=>tx.get(ref)));
    if(snapshots.some(snapshot=>snapshot.exists())){
      if(!snapshots.every(snapshot=>snapshot.exists()&&snapshot.data().saveGroupId===trade.id))throw new Error('This save changed in another window. Refresh your journal before trying again.');
      return {trades:snapshots.map(snapshot=>snapshot.data()),alreadySaved:true};
    }
    copies.forEach((copy,i)=>tx.set(refs[i],copy));
    return {trades:copies,alreadySaved:false};
  });
}

export async function moveToRecentlyDeleted(db,uid,id,now=Date.now()){
  const target=doc(db,'users',uid,'trades',id);
  return runTransaction(db,async tx=>{
    const snapshot=await tx.get(target);
    if(!snapshot.exists()||snapshot.data().deleted)throw new Error('This trade is no longer available. Refresh your journal.');
    const current=snapshot.data();
    tx.update(target,{isPublic:false,deleted:true,deletedAt:now});
    return {...current,isPublic:false,deleted:true,deletedAt:now};
  });
}

export async function restoreDeletedTrade(db,uid,id){
  const target=doc(db,'users',uid,'trades',id);
  return runTransaction(db,async tx=>{
    const snapshot=await tx.get(target);
    if(!snapshot.exists())throw new Error('This trade has already been removed.');
    if(snapshot.data().deleted!==true)return;
    // Read the latest archived state and notes; never republish on restore.
    tx.update(target,{deleted:false,deletedAt:null,isPublic:false});
  });
}

export async function removeDeletedTrade(db,uid,id,{expiredOnly=false,now=Date.now()}={}){
  const target=doc(db,'users',uid,'trades',id);
  return runTransaction(db,async tx=>{
    const snapshot=await tx.get(target);
    if(!snapshot.exists()||snapshot.data().deleted!==true)return false;
    const deletedAt=snapshot.data().deletedAt;
    if(expiredOnly&&(!Number.isFinite(deletedAt)||now-deletedAt<5*86400000))return false;
    tx.delete(target);
    // Image URLs may be shared by older multi-account copies. Storage cleanup
    // belongs to reviewed account maintenance, never a stale browser callback.
    return true;
  });
}
